import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0ebc646"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "row" }

import FileUploader from '@/components/FileUploader.vue';
import FileTable from '@/components/FileTable.vue';
import CSVConfigSelector from '@/components/CSVConfigSelector.vue';
import CircuitSelector from '@/components/CircuitSelector/CircuitSelector.vue';
import ParameterTable from '@/components/ParameterTable.vue';
import FittingExecutant from '@/components/FittingExecutant.vue';
import NyquistPlot from '@/components/NyquistPlot.vue';

import { computed, inject} from "vue";
import { key } from '@/components/FileManager';
import { PlotData } from '@/components/Impedance';
import BodePlot from '@/components/BodePlot.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CircuitFittingView',
  setup(__props) {

const data = computed(()=>{
  return files?.keys().map(key=>{
    const impedance = files.files[key].impedance;
    const fitting = files.files[key].fitting_result;
    console.log(impedance);
    let output = {} as PlotData;

    output.name = files.files[key].file.name;
    output.f = impedance.f;
    output.rs = impedance.rs;
    output.x = impedance.x;
    if(fitting.isDone){
      output.f_calc = fitting.f_calc;
      output.rs_calc = fitting.rs_calc;
      output.x_calc = fitting.x_calc;
    }
    return output;
  });
})
const files = inject(key);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FileUploader),
    _createVNode(CSVConfigSelector),
    _createVNode(FileTable),
    _createVNode(CircuitSelector),
    _createVNode(FittingExecutant),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NyquistPlot, {
        data: _unref(data),
        config: {zeroline: true}
      }, null, 8, ["data"]),
      _createVNode(BodePlot, { data: _unref(data) }, null, 8, ["data"])
    ]),
    _createVNode(ParameterTable)
  ]))
}
}

})